module.exports = __webpack_public_path__ + "img/chinesecompany37.8c4f9036.png";